import { PlusCircle, Search, MoreHorizontal } from 'lucide-react';
import { Link } from 'react-router-dom';

import { DashboardLayout } from '@/components/dashboard/DashboardLayout';
import { PageHeader } from '@/components/dashboard/PageHeader';
import { StatusBadge } from '@/components/dashboard/StatusBadge';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { campaigns, fmt, gameLabels } from '@/lib/mockData';

const PartenaireCampagnes = () => (
  <DashboardLayout
    role="partenaire"
    user={{ name: 'Marie Koné', subtitle: 'Orange CI', initials: 'MK' }}
  >
    <PageHeader
      title="Campagnes"
      subtitle="Toutes les activations — actives, programmées, terminées."
      actions={
        <Button size="sm" asChild className="shadow-cta">
          <Link to="/partenaire/nouvelle">
            <PlusCircle className="size-4" />
            Nouvelle campagne
          </Link>
        </Button>
      }
    />

    <div className="mb-4 flex flex-wrap items-center gap-3">
      <div className="relative w-full max-w-sm">
        <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
        <Input placeholder="Rechercher une campagne…" className="h-10 pl-9" />
      </div>
      <div className="flex flex-wrap gap-2 text-sm">
        {['Toutes', 'Actives', 'Programmées', 'Terminées'].map((f, i) => (
          <button
            key={f}
            className={
              i === 0
                ? 'rounded-full bg-foreground px-3.5 py-1.5 text-xs font-semibold text-background'
                : 'rounded-full border border-border bg-card px-3.5 py-1.5 text-xs font-semibold text-muted-foreground hover:bg-muted'
            }
          >
            {f}
          </button>
        ))}
      </div>
    </div>

    <div className="overflow-hidden rounded-2xl border border-border bg-card shadow-soft">
      <table className="w-full text-sm">
        <thead className="border-b border-border bg-muted/50">
          <tr className="text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            <th className="px-5 py-3">Campagne</th>
            <th className="px-5 py-3">Jeu</th>
            <th className="px-5 py-3">Période</th>
            <th className="px-5 py-3 text-right">Participations</th>
            <th className="px-5 py-3 text-right">Lots</th>
            <th className="px-5 py-3">Statut</th>
            <th className="px-5 py-3" />
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {campaigns.map(c => (
            <tr key={c.id} className="hover:bg-muted/30">
              <td className="px-5 py-3">
                <p className="font-semibold">{c.name}</p>
                <p className="text-xs text-muted-foreground">
                  {c.brand} • {c.city}
                </p>
              </td>
              <td className="px-5 py-3 text-muted-foreground">{gameLabels[c.game]}</td>
              <td className="px-5 py-3 text-xs text-muted-foreground">
                {c.startDate} → {c.endDate}
              </td>
              <td className="px-5 py-3 text-right font-medium">{fmt.number(c.participations)}</td>
              <td className="px-5 py-3 text-right text-muted-foreground">
                {fmt.number(c.prizesGiven)} / {c.totalPrizes}
              </td>
              <td className="px-5 py-3">
                <StatusBadge status={c.status} />
              </td>
              <td className="px-5 py-3 text-right">
                <Button variant="ghost" size="icon" aria-label="Actions">
                  <MoreHorizontal className="size-4" />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </DashboardLayout>
);

export default PartenaireCampagnes;
